import type { CloudEnvironmentStorage } from '../types/CloudEnvironmentStorage';
import type { CloudEnvironment } from '../types/CloudEnvironment';
import type { CloudEnvironmentMetadata } from '../types/CloudEnvironmentMetadata';

export class CachingCloudEnvironmentStorageDecorator implements CloudEnvironmentStorage {
    private storage: CloudEnvironmentStorage;
    private cache: Map<string, CloudEnvironment> = new Map();

    constructor(storage: CloudEnvironmentStorage) {
        this.storage = storage;
    }

    async getConfigForDomain(domain: string): Promise<CloudEnvironment | undefined> {
        if (this.cache.has(domain)) {
            return this.cache.get(domain);
        }

        const cloudEnv = await this.storage.getConfigForDomain(domain);
        if (cloudEnv) {
            this.cache.set(domain, cloudEnv);
        }
        return cloudEnv;
    }

    async putConfigForDomain(
        domain: string,
        cloudEnv: CloudEnvironment,
        metadata: CloudEnvironmentMetadata
    ): Promise<void> {
        this.cache.set(domain, cloudEnv);
        return this.storage.putConfigForDomain(domain, cloudEnv, metadata);
    }

    async getDomainsToRefresh(): Promise<string[]> {
        return this.storage.getDomainsToRefresh();
    }

    async exportConfigs(): Promise<string> {
        return this.storage.exportConfigs();
    }

    importConfigs(configsPayload: string): void {
        this.storage.importConfigs(configsPayload);
    }
}
